var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { justify: "center" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "text-h5" }, [
                  _vm._v("Nuevo Reporte")
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.itemsCodVehiculo,
                                  label: "Patente",
                                  "item-text": "patente_vehiculo",
                                  "item-value": "id",
                                  "return-object": ""
                                },
                                model: {
                                  value: _vm.formsFields.patente,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formsFields, "patente", $$v)
                                  },
                                  expression: "formsFields.patente"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formsFields.fechaDesdeNew.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formsFields.fechaDesdeNew.id
                                  ),
                                  id: _vm.formsFields.fechaDesdeNew.id,
                                  min: _vm.fechaMinima,
                                  max: _vm.fechaMaxima
                                },
                                on: { input: _vm.validateDates },
                                model: {
                                  value: _vm.formsFields.fechaDesdeNew.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formsFields.fechaDesdeNew,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formsFields.fechaDesdeNew.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formsFields.fechaHastaNew.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formsFields.fechaHastaNew.id
                                  ),
                                  id: _vm.formsFields.fechaHastaNew.id,
                                  min: _vm.fechaMinima,
                                  max: _vm.fechaMaxima
                                },
                                on: { input: _vm.validateDates },
                                model: {
                                  value: _vm.formsFields.fechaHastaNew.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formsFields.fechaHastaNew,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formsFields.fechaHastaNew.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.onClose }
                    },
                    [_vm._v("\n          Cancelar\n        ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.onSave }
                    },
                    [_vm._v("\n          Generar\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }